const styles = {
    loaderContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "50vh",
    },
    paginationContainer: {
        marginTop: "20px",
        display: "flex",
        justifyContent: "flex-end",
    },
    dataGridSx: {
        "& .MuiInputBase-root button svg.MuiSvgIcon-fontSizeSmall": {
            display: "none",
            backgroundColor: "red",
        },
        "& .css-dwjt6a-MuiButtonBase-root-MuiIconButton-root": {
            display: "none",
        },
        "&:hover .css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
            background: "#674188",
        },
        ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            width: "1px",
            height: "4px",
        },
        ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
            background: "#F7EFE5",
        },
        ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
            background: "rgba(103, 65, 136, 0.5)",
            borderRadius: "10px",
        },
    },
    dialogContent: {
        paddingTop: "8px",
    },
    detailRow: {
        display: "grid",
        gridTemplateColumns: "180px 1fr",
        gap: "8px",
        marginBottom: "10px",
    },
    detailLabel: {
        fontWeight: 600,
        color: "#555",
    },
    detailValue: {
        color: "#222",
        wordBreak: "break-word",
    },
};

export default styles;


